import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getRoute, loading } from '../../../actions/sessions';
import { asyncActions } from '../../../actions/general';
import { getCreditLineAvailable } from '../../../actions/companies';
import { formatCurrency } from '../../../lib/formatters';
import { borrowerPortalUrl } from '../../../constants/SiteVariables';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useSessionEntity from '../../../hooks/useSessionEntity';
import Error from '../../shared/Error';
import Loading from '../../shared/Loading';

export default function HasCreditChanges({ location }) {
  const dispatch = useDispatch();

  const application = useSessionEntity('application');
  const company = useSessionEntity('company');

  const [tclAvailable, setTclAvailable] = useState(0);
  const NextButton = () => {
    return (<button
      type="button"
      role="submit"
      className='mt-2 button is-large is-fullwidth is-info is-size-5 has-text-weight-semibold'
      onClick={nextScreen}>
      Next
    </button>);
  };

  const nextScreen = (e) => {
    e.preventDefault();

    dispatch(loading(true));
    dispatch(asyncActions(
      getRoute()
    ))
      .then(res => dispatch(loading(false)));
  };

  useEffect(() => {
    if (company) {
      dispatch(asyncActions(
        getCreditLineAvailable(company.id)
      ))
        .then(res => setTclAvailable(res.attributes.data));
    }
  }, [company, dispatch]);

  useRouteStatus(location);

  if(!application || !company) return <Loading active={true} />

  if (parseFloat(application.previous_tcl) < parseFloat(company.credit_line.get('amount'))) {
    return (
      <div role="main" id="content" className="has-text-centered">
        <h1 className="is-size-1">Good News!</h1>
        <h2>You’ve earned an increase in your Credit Key credit line.</h2>

        <Error />

        <p>
          Your credit limit of {formatCurrency(application.previous_tcl)} has been increased
          to <span className="text-green-highlight">{formatCurrency(company.credit_line.get('amount'))}</span>.
        </p>
        <p>You currently have {formatCurrency(tclAvailable)} available to spend.</p>
        <NextButton />
      </div>
    );
  } else {
    return (
      <div role="main" id="content" className="has-text-centered">
        <h1 className="is-size-1">Quick heads-up</h1>
        <p>
          There's been an across the board update to credit limits due to market conditions and necessary underwriting changes. Your new credit limit is {formatCurrency(company.credit_line.get('amount'))}, with {tclAvailable < 0 ? '$0' : formatCurrency(tclAvailable)} remaining.
        </p>
        <p className='my-2'>You can request a line increase by submitting 3 months' bank statements
          <a href='https://www.creditkey.com/credit-key-increase-request' target="_blank" className='has-text-weight-semibold ml-1'>here</a>.</p>

        <Error />

        {tclAvailable < 0 &&
          <p>
            <strong>You are currently over your limit.</strong> Please log into
            your <a href={borrowerPortalUrl} target="_blank">dashboard</a> to make a payment at your
            earliest convenience.
          </p>
        }
        <NextButton />
      </div>
    );
  }
}
